import styled, {css} from 'styled-components';

import PieButton from '~/shared/theme/pie/PieButton';
import {flexColumn} from '~/shared/theme/FlexLayout';
import {media} from '~/shared/theme/media';
import {smallRegular, subheadingSBold} from '~/shared/theme/typography';

/* The top stop of the success gradient. The two below it are theme colours; this one is only ever
   used as the end of this gradient, so the design system has no name for it. */
const successGradientTop = '#FF9667';

/* Paints the whole success screen: one gradient running from the orange behind the cash down to
   white behind the action. The design defines it over a box 528px tall pinned to the top of the
   sheet - taller than the sheet itself, so the bottom of the ramp is cut off rather than squeezed in.
   The modal is short enough to take the full ramp. */
export const successGradient = css`
  background-color: ${({theme}) => theme.colors.actionWhite};
  background-image: linear-gradient(
    0deg,
    ${({theme}) => theme.colors.actionWhite} 20.865%,
    ${({theme}) => theme.colors.orange0} 52.444%,
    ${({theme}) => theme.colors.orange10} 83.818%,
    ${successGradientTop} 109.75%
  );
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 528px;
  ${media.minLargeMobile`
    background-size: 100% 100%;
  `}
`;

/* Layout shared by every screen of the flow, so the header decoration stays put and only the body
   content swaps as the conversion progresses. */

/* The bottom inset on mobile keeps the actions clear of the phone's home-gesture area. Screens that
   render the header decoration pad their own top on top of this, to clear the overhanging wallet. */
export const Body = styled.div`
  ${flexColumn}
  flex: 1;
  align-items: center;
  padding: 32px 16px 40px;
  ${media.minLargeMobile`
    flex: none;
    padding: 32px 24px 24px;
  `}
`;

export const TextBlock = styled.div`
  ${flexColumn}
  align-items: center;
  gap: 16px;
  text-align: center;
`;

export const Subtitle = styled.h2`
  ${subheadingSBold}
  margin: 0;
  color: ${({theme}) => theme.colors.contentDefault};
`;

export const Disclaimer = styled.p`
  ${smallRegular}
  margin: 0;
  color: ${({theme}) => theme.colors.contentInteractiveSubdued};
`;

export const ButtonsContainer = styled.div`
  ${flexColumn}
  gap: 16px;
  width: 100%;

  /* Pins the actions to the bottom of the fixed-height sheet on mobile. */
  margin-top: auto;
  ${media.minLargeMobile`
    flex-direction: row;
    align-items: stretch;
    margin-top: 32px;
  `}
`;

export const ActionButton = styled(PieButton)`
  width: 100%;
  ${media.minLargeMobile`
    flex: 1;
    /* The design's desktop actions are 48px tall, one step above the Large variant's padding. */
    padding: 12px 16px;
  `}
`;
